import React from 'react';
import { Link } from 'gatsby';

import { Helmet } from 'react-helmet';

import { Mastodon, Discord, RssFill } from 'react-bootstrap-icons';

import { ThemeContext } from '../../context/themecontext';
import Seo from '../../components/layout/seo';
import MainMenu from '../../components/menus/mainmenu';
import UserMenu from '../../components/menus/usermenu';

import logo from '../../../static/images/banner.svg';

import './layout.css';

export const Layout = (props) => {
	const userTheme = React.useContext(ThemeContext);
	const { meta, children } = props;

	return (
		<React.Fragment>
			<Helmet>
				<title>{meta && meta.title ? `${meta.title} ~ Tower of the Hand` : `Tower of the Hand ~ An Ice and Fire Site`}</title>
			</Helmet>
			<Seo meta={meta} />
			{userTheme.theme !== '' && (
				<React.Fragment>
					<Helmet>
						<link
							rel='stylesheet'
							href='https://fonts.googleapis.com/css?family=Lora'
						/>
						<link
							rel='stylesheet'
							href='https://cdn.jsdelivr.net/npm/bootstrap@5.2.0-beta1/dist/css/bootstrap.min.css'
							integrity='sha384-0evHe/X+R7YkIZDRvuzKMRqM+OrBnVFBL6DOitfPri4tjfHxaWutUpFmBp4vmVor'
							crossorigin='anonymous'
						/>
						<body className={userTheme.theme === 'dark' ? 'dark' : 'light'} />
					</Helmet>
					<LayoutBanner />
					<div id='content'>
						{children}
					</div>
					<LayoutFooter />
				</React.Fragment>
			)}
		</React.Fragment>
	);
}

const LayoutBanner = () => {
	return (
		<header id='banner'>
			<div id='banner-flex'>
				<div className='sitename'><Link to='/'><img src={logo} alt='Logo' /></Link></div>
				<div className='actionicons'>
					<span>
						<UserMenu />
					</span>
					<span>
						<MainMenu />
					</span>
				</div>
			</div>
		</header>
	);
};

const LayoutFooter = () => {
	return (
		<footer id='footer'>
			<div>
				<Link to='/'>Tower of the Hand</Link>
				<div style={{ fontSize: '.9em' }}>
					<Link to='/about/'>About</Link> | <Link to='/about/terms-of-services/'>Terms</Link> | <Link to='/about/privacy/'>Privacy</Link> | <Link to='/contact/'>Contact Us</Link>
				</div>
			</div>
			<div id='social' style={{ fontSize: '.9em' }}>
				<a rel='me' href='https://mas.to/@towerofthehand' title='Mastodon' aria-label='Mastodon'><Mastodon size='16' /></a> <a href='https://discord.gg/M9bf8RakSA' title='Discord' aria-label='Discord'><Discord size='16' /></a> <a rel='me' href='https://towerofthehand.com/rss.xml' title='RSS' aria-label='RSS'><RssFill size='16' /></a>
			</div>
			<div id='copyright'>
				<p>
					Content licensed under a <a rel='license' href='https://creativecommons.org/licenses/by-nc-nd/3.0/' title='Creative Commons Attribution-NonCommercial-NoDerivs 3.0 Unported License'>Creative Commons Attribution 3.0 License</a>.
				</p>
				<p>
					A Song of Ice and Fire TM and copyright <a href='https://www.georgerrmartin.com/' title='George R. R. Martin'>George R. R. Martin</a>.
					<br/>Game of Thrones TM and copyright <a href='https://www.hbo.com/' title='Home Box Office, Inc.'>HBO</a>.
				</p>
			</div>
		</footer>
	);
};
